// ─────────────────────────────────────────────────────────────────────
// <MegaMenu /> — appears on hover of nav items with megaKey
// ─────────────────────────────────────────────────────────────────────

import { Link } from 'react-router-dom';
import { useCategories, FLOWER_GLYPH } from '@/lib/taxonomy';   // r7.6.4 live taxonomy

const MENUS = {
  events: {
    columns: [
      {
        title: 'Tonight',
        links: [
          { to: '/v/live-events?when=today',     label: 'Happening today' },
          { to: '/v/live-events?when=tomorrow',  label: 'Tomorrow' },
          { to: '/v/live-events?when=weekend',   label: 'This weekend' },
        ],
      },
      {
        title: 'By mood',
        links: [
          { to: '/m/quiet-evening',  label: 'Quiet evening' },
          { to: '/m/date-night',     label: 'Date night' },
          { to: '/m/family-day',     label: 'Family day out' },
          { to: '/m/late-night',     label: 'Late night' },
          { to: '/m/under-500',      label: 'Under ₹500' },
        ],
      },
      { title: 'By category', taxonomy: true },   // r7.6.4 — filled from /api/categories at render
      {
        title: 'Featured',
        featured: true,
        links: [
          { to: '/curated/this-week',  label: 'This week\'s pick', subtitle: 'Curated by editors' },
        ],
      },
    ],
  },
};

export default function MegaMenu({ menuKey, onSelect }) {
  const menu = MENUS[menuKey];
  const { categories } = useCategories();
  if (!menu) return null;
  const columns = menu.columns.map((col) => col.taxonomy
    ? { ...col, links: [...categories.slice(0, 7).map((c) => ({ to: `/c/${c.slug}`, label: `${FLOWER_GLYPH[c.slug] || '✿'} ${c.name}`, slug: c.slug })), { to: '/c', label: 'All categories →' }] }
    : col);

  return (
    <div
      className="rounded-card border border-line p-7"
      style={{
        background: 'var(--snt-bg-1)',
        minWidth: '720px',
        boxShadow: '0 12px 40px rgba(0,0,0,0.5)',
      }}
      onClick={(e) => e.stopPropagation()}
    >
      <div className="grid grid-cols-4 gap-8">
        {columns.map((col, i) => (
          <div key={i}>
            <div className="snt-micro text-text-3 mb-3">{col.title}</div>
            {col.featured ? (
              <div>
                {col.links.map((link) => (
                  <Link
                    key={link.to}
                    to={link.to}
                    onClick={onSelect}
                    className="block no-underline"
                  >
                    <div
                      className="rounded-card aspect-[4/3] mb-3 flex items-center justify-center font-serif text-[40px] opacity-50 snt-art-gold"
                    >
                      ✦
                    </div>
                    <div className="text-[13px] text-text font-serif">{link.label}</div>
                    {link.subtitle && (
                      <div className="text-[11px] text-text-3 mt-1">{link.subtitle}</div>
                    )}
                  </Link>
                ))}
              </div>
            ) : (
              <ul className="space-y-2">
                {col.links.map((link) => (
                  <li key={link.to}>
                    <Link
                      to={link.to}
                      onClick={onSelect}
                      className="text-[13px] text-text-2 hover:text-accent transition-colors no-underline"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
